/* FABEL — variant-selector.js : option state, price, availability, media, URL. */
(function () {
  'use strict';
  const FABEL = window.FABEL;

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.productUrl = this.dataset.url;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.variants = this.readVariants();
      this.optionCount = parseInt(this.dataset.optionCount || '0', 10);

      this.addEventListener('change', this.onChange.bind(this));
      this.updateAvailability();
      this.currentVariant = this.matchVariant();
      if (this.currentVariant) this.publish(false);
    }

    readVariants() {
      const script = this.querySelector('[data-variant-data]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent) || [];
      } catch (e) {
        return [];
      }
    }

    /* Selected value per option position; null when the customer has not chosen. */
    get selection() {
      const values = [];
      for (let i = 1; i <= this.optionCount; i += 1) {
        const checked = this.querySelector(`input[data-option-position="${i}"]:checked`);
        if (checked) {
          values.push(checked.value);
          continue;
        }
        const select = this.querySelector(`select[data-option-position="${i}"]`);
        values.push(select && select.value ? select.value : null);
      }
      return values;
    }

    matchVariant() {
      const selection = this.selection;
      if (selection.some((value) => value === null)) return null;
      return (
        this.variants.find((variant) =>
          variant.options.every((option, index) => option === selection[index])
        ) || null
      );
    }

    onChange(event) {
      if (!event.target.matches('[data-option-position]')) return;
      this.currentVariant = this.matchVariant();
      this.updateAvailability();
      this.updateOptionLabels();
      this.publish(true);
    }

    /* Cross out combinations that do not exist / are sold out. */
    updateAvailability() {
      const selection = this.selection;
      for (let position = 1; position <= this.optionCount; position += 1) {
        const inputs = this.querySelectorAll(`input[data-option-position="${position}"]`);
        inputs.forEach((input) => {
          const candidate = selection.slice();
          candidate[position - 1] = input.value;
          const exists = this.variants.some((variant) =>
            variant.options.every((option, index) => {
              const wanted = candidate[index];
              return wanted === null || wanted === undefined || option === wanted;
            })
          );
          const available = this.variants.some(
            (variant) =>
              variant.available &&
              variant.options.every((option, index) => {
                const wanted = candidate[index];
                return wanted === null || wanted === undefined || option === wanted;
              })
          );
          const visual = input.nextElementSibling;
          input.disabled = !exists;
          if (visual) visual.setAttribute('data-available', available ? 'true' : 'false');
          input.closest('.swatch-wrap, .option__value-wrap')?.setAttribute(
            'data-available',
            available ? 'true' : 'false'
          );
        });
      }
    }

    updateOptionLabels() {
      this.querySelectorAll('[data-option-current]').forEach((el) => {
        const position = parseInt(el.getAttribute('data-option-current'), 10);
        const checked = this.querySelector(`input[data-option-position="${position}"]:checked`);
        const select = this.querySelector(`select[data-option-position="${position}"]`);
        el.textContent = checked ? checked.value : select ? select.value : '';
      });
    }

    publish(interactive) {
      const variant = this.currentVariant;

      if (this.updateUrl && variant && interactive && this.productUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      const input = document.querySelector(`[data-variant-id-input="${this.sectionId}"]`);
      if (input) input.value = variant ? variant.id : '';

      FABEL.publish('variant:change', {
        sectionId: this.sectionId,
        variant,
        incomplete: !variant && this.selection.some((value) => value === null)
      });
    }
  }

  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  /* ------------------------------------------------- price + availability */
  FABEL.subscribe('variant:change', (payload) => {
    const { sectionId, variant } = payload;
    const scope = document.querySelector(`[data-product-scope="${sectionId}"]`);
    if (!scope) return;

    const priceEl = scope.querySelector('[data-product-price]');
    if (priceEl && variant && variant.price_html) priceEl.innerHTML = variant.price_html;

    const sku = scope.querySelector('[data-product-sku]');
    if (sku) {
      sku.textContent = variant && variant.sku ? variant.sku : '';
      sku.closest('[data-product-sku-wrap]')?.toggleAttribute('hidden', !(variant && variant.sku));
    }

    const buttons = scope.querySelectorAll('[data-add-button]');
    buttons.forEach((button) => {
      const text = button.querySelector('.btn__text');
      if (!variant) {
        button.disabled = false;
        if (text) text.textContent = FABEL.strings.addToCart;
        return;
      }
      button.disabled = !variant.available;
      if (text) text.textContent = variant.available ? FABEL.strings.addToCart : FABEL.strings.soldOut;
    });

    scope.querySelectorAll('[data-sticky-price]').forEach((el) => {
      if (variant && variant.price_html) el.innerHTML = variant.price_html;
    });
    scope.querySelectorAll('[data-sticky-variant]').forEach((el) => {
      el.textContent = variant ? variant.title.replace(/ \/ /g, ' · ') : '';
    });
  });
})();
